import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const UserIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "user",
  "UserIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M7.99967 2.66671C6.8951 2.66671 5.99967 3.56214 5.99967 4.66671C5.99967 5.77128 6.8951 6.66671 7.99967 6.66671C9.10424 6.66671 9.99967 5.77128 9.99967 4.66671C9.99967 3.56214 9.10424 2.66671 7.99967 2.66671ZM4.66634 4.66671C4.66634 2.82576 6.15872 1.33337 7.99967 1.33337C9.84062 1.33337 11.333 2.82576 11.333 4.66671C11.333 6.50766 9.84062 8.00004 7.99967 8.00004C6.15872 8.00004 4.66634 6.50766 4.66634 4.66671ZM2.33301 12.6667C2.33301 10.8258 3.82539 9.33337 5.66634 9.33337H10.333C12.174 9.33337 13.6663 10.8258 13.6663 12.6667V13.6667H12.333V12.6667C12.333 11.5621 11.4376 10.6667 10.333 10.6667H5.66634C4.56177 10.6667 3.66634 11.5621 3.66634 12.6667V13.6667H2.33301V12.6667Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default UserIcon;
